// Leave dates are civil dates ("2026-12-28"), not instants. `new Date(s)` reads
// them as UTC midnight, which renders as the previous day for any UTC-negative
// viewer (a Dec 28 request showed as "Dec 27" on the approvals card), so anchor
// them locally via toDisplayDate before formatting.
import { toDisplayDate } from '@/lib/orgFormat';

const fmtDay = (s: string) => toDisplayDate(s).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });

export const fmtRange = (s: string, e?: string) => {
  if (!s) return '—';
  if (!e || e === s) return fmtDay(s);
  return `${fmtDay(s)} – ${fmtDay(e)}`;
};
